
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[nonprofitSlugOrUsername]",
      function () {
        return require("private-next-pages/[nonprofitSlugOrUsername]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[nonprofitSlugOrUsername]"])
      });
    }
  